@if (_question$ | async; as question) {
  <lib-question-display [question]="question.value" />
  <ion-range
    [min]="question.scaleRange.min"
    [max]="question.scaleRange.max"
    [step]="question.step"
    [formControl]="rangeCtrl"
  />
  <div class="labels-container">
    @for (
      label of question.scaleQuestionLabels;
      track label;
      let index = $index
    ) {
      <!-- Create the space between the labels -->
      @if (index === 0) {
        <div
          [style.flex]="label.onScalePoint - question.scaleRange.min + ' 0 0px'"
        >
          <!--spacing-->
        </div>
      }
      @if (index !== 0) {
        <div
          [style.flex]="
            label.onScalePoint -
            question.scaleRange.min -
            question.scaleQuestionLabels[index - 1].onScalePoint +
            ' 0 0px'
          "
        >
          <!--spacing-->
        </div>
      }
      @if (index >= question.scaleQuestionLabels.length - 1) {
        <div
          [style.flex]="
            label.onScalePoint -
            question.scaleRange.min -
            question.scaleRange.max -
            question.scaleRange.min +
            ' 0 0px'
          "
        >
          <!--spacing-->
        </div>
      }
      <!-- Add the label after the space -->
      <div
        class="label-position"
        [class.mobile-hidden]="
          index !== 0 && index < question.scaleQuestionLabels.length - 1
        "
      >
        <ion-label
          class="label"
          [class.first]="index === 0"
          [class.last]="index >= question.scaleQuestionLabels.length - 1"
          >{{ label.title }}</ion-label
        >
      </div>
    }
  </div>
}
